// extracted by mini-css-extract-plugin
export default {"button":"button_button__rI4nD","contained":"button_contained__r5lRX","label":"button_label__XU7g6"};